
export default {
  install(Vue, { store }) {

    if (!store)
      throw new Error('Please provide vuex store.');

    store.registerModule('notify', {
      getters: {
        getNotifications: state => state.notifications
      },
      mutations: {
        addNotification(state, { message, type='success', closingTime, title }) {
          if (Array.isArray(message))
            message.forEach(m => state.notifications.push({ closingTime, id: nextId(), message: m, title, type }))
          else
            state.notifications.push({ closingTime, id: nextId(), message, title, type })
        }
      },
      state: {
        notifications: []
      }
    })

    const methods = {
      add(message, { type = 'success', closingTime } = {}) {
        store.commit('addNotification', {
          closingTime: closingTime,
          message: message,
          type: type
        })
      },
      addError(message) {
        let newMessage = 'Ops.. Ocorreu um erro! Tente novamente.'

        if (message instanceof TypeError) {
          newMessage = message.message
        } else if (message && typeof message === 'object' && message.errors) {
          newMessage = message.errors
        } else if (message && typeof message === 'string') {
          newMessage = message
        }

        store.commit('addNotification', {
          message: newMessage, type: 'error'
        })
      },
      notifications() {
        return store.getters.getNotifications
      }
    }

    Object.defineProperties(this, {
      notifications: { get: () => { return store.getters.getNotifications } },
    })
    Vue.notify = methods
    Vue.prototype.$notify = methods
  }
}

let id = 0
function nextId() {
  return id++
}
